/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnavailableFeature
 */
export interface UnavailableFeature {
    /**
     * 
     * @type {string}
     * @memberof UnavailableFeature
     */
    feature: string;
    /**
     * 
     * @type {string}
     * @memberof UnavailableFeature
     */
    message: string;
}

export function UnavailableFeatureFromJSON(json: any): UnavailableFeature {
    return UnavailableFeatureFromJSONTyped(json, false);
}

export function UnavailableFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnavailableFeature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'feature': json['feature'],
        'message': json['message'],
    };
}

export function UnavailableFeatureToJSON(value?: UnavailableFeature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'feature': value.feature,
        'message': value.message,
    };
}

